import { Button, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDynamicPagesContext } from "../../../../context/dynamic-pages-context";

const UpdateTypesForm = ({ dataSingle }) => {
  const [data, setData] = useState({
    title: "",
    description: "",
    id: "",
  });

  const { updateTypes } = useDynamicPagesContext();

  const handleUpdate = async () => {
    const response = await updateTypes(data.id, data);

    console.log(response, "dsa");
  };

  useEffect(() => {
    setData(dataSingle);
  }, [dataSingle]);

  return (
    <Stack spacing={2} width={400}>
      <TextField
        fullWidth
        value={data.title}
        label="Title"
        onChange={(e) =>
          setData({
            ...data,
            title: e.target.value,
          })
        }
        variant="outlined"
        required
      />
      <small>
        *note : this is the page name that you want to create, currently do not
        change these . on web it is hard coded . it will break the site
      </small>
      <TextField
        required
        fullWidth
        value={data.description}
        label="Description"
        variant="outlined"
        multiline
        rows={4}
        onChange={(e) =>
          setData({
            ...data,
            description: e.target.value,
          })
        }
      />
      <small>
        *note : this description is not shown anywhere , its just for admin
      </small>
      <Button onClick={handleUpdate} variant="contained" color="primary">
        Submit
      </Button>
    </Stack>
  );
};

export default UpdateTypesForm;
